import { BUILDER_DESRIPTION_LIMIT } from '../../../../constants/builder';

export const getDisplayDescription = (description?: string | null): string | null => {
  if (!description?.length) {
    return null;
  }

  const displayDescriptionText = description.slice(0, BUILDER_DESRIPTION_LIMIT);
  const displayDescriptionEnding = description.length > displayDescriptionText.length ? '…' : '';

  return displayDescriptionText + displayDescriptionEnding;
};
